import Phaser from 'phaser';
import { getTunables } from '../config/tunables';

export type EnemyKind = 'charger' | 'flanker' | 'shooter' | 'burster';

export type EnemyDefinition = {
  kind: EnemyKind;
  label: string;
  radius: number;
  color: number;
  stroke: number;
  speed: number;
  hp: number;
  unlockAtMs: number;
};

export const ENEMY_DEFINITIONS: Record<EnemyKind, EnemyDefinition> = {
  charger: {
    kind: 'charger',
    label: '直冲',
    radius: 13,
    color: 0xd95b4f,
    stroke: 0xffc0a7,
    speed: 86,
    hp: 12,
    unlockAtMs: 0,
  },
  flanker: {
    kind: 'flanker',
    label: '绕行',
    radius: 12,
    color: 0x9b6cff,
    stroke: 0xe1d0ff,
    speed: 78,
    hp: 10,
    unlockAtMs: 9000,
  },
  shooter: {
    kind: 'shooter',
    label: '远程',
    radius: 12,
    color: 0x5bb8ff,
    stroke: 0xc8efff,
    speed: 58,
    hp: 9,
    unlockAtMs: 17000,
  },
  burster: {
    kind: 'burster',
    label: '爆裂',
    radius: 14,
    color: 0xffa333,
    stroke: 0xffebaa,
    speed: 96,
    hp: 8,
    unlockAtMs: 25000,
  },
};

export class EnemyToken extends Phaser.GameObjects.Arc {
  public declare body: Phaser.Physics.Arcade.Body;
  public kind: EnemyKind = 'charger';
  public hp = 1;
  public speed = 1;
  public phase = 0;
  public turn = 1;

  constructor(scene: Phaser.Scene) {
    super(scene, 0, 0, 10, 0, 360, false, ENEMY_DEFINITIONS.charger.color, 1);
    this.setVisible(false);
    this.setActive(false);
  }

  activate(definition: EnemyDefinition, x: number, y: number, phase: number, turn: number) {
    const wave = Math.max(1, Number(this.scene.registry.get('m1.wave')) || 1);
    const tunables = getTunables();
    const hpMultiplier = tunables.enemies.hpMultiplier * (1 + tunables.enemies.hpPerWave * (wave - 1));
    const speedMultiplier = tunables.enemies.speedMultiplier * (1 + tunables.enemies.speedPerWave * (wave - 1));
    this.kind = definition.kind;
    this.hp = Math.max(1, definition.hp * hpMultiplier);
    this.setData('maxHp', this.hp);
    this.speed = definition.speed * speedMultiplier;
    this.phase = phase;
    this.turn = turn;
    this.setPosition(x, y);
    this.setRadius(definition.radius);
    this.setFillStyle(definition.color, 1);
    this.setStrokeStyle(2, definition.stroke, 0.9);
    this.setVisible(true);
    this.setActive(true);
    this.body.enable = true;
    this.body.setCircle(definition.radius);
    this.body.setOffset(-definition.radius, -definition.radius);
    this.body.setVelocity(0, 0);
  }

  deactivate() {
    this.setVisible(false);
    this.setActive(false);
    this.body.enable = false;
    this.body.setVelocity(0, 0);
  }
}
